var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CEESAR-DialogHost"},[_c('div',{class:['CEESAR-DialogHostMask',
                  _vm.isDialogShown? 'CEESAR-DialogHostMask-Visible': 'CEESAR-DialogHostMask-Hidden']}),_c('div',{class:['CEESAR-DialogHostContent',
                  _vm.isDialogShown? 'CEESAR-DialogHostContent-Visible': 'CEESAR-DialogHostContent-Hidden'],attrs:{"id":"DialogHostContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }